/**
 * C2 dashboard view-model — pure display shaping (bar-chart scaling + status
 * donut) kept out of the .vue so node:test can cover the logic directly (the
 * companies repo has no SFC test runner). The template just binds the output.
 */
var STATUS_COLOR = {
  active: 'var(--v-ok)',
  suspended: 'var(--v-warn)',
  left: 'var(--v-danger)',
};

function barData(employeesByMonth) {
  var rows = employeesByMonth || [];
  var max = 0;
  for (var i = 0; i < rows.length; i++) max = Math.max(max, rows[i].count);
  return rows.map(function (m) {
    return {
      month: m.month,
      count: m.count,
      pct: max > 0 ? Math.round((m.count / max) * 100) : 0,
    };
  });
}

function donut(employeesByStatus) {
  var rows = employeesByStatus || [];
  var total = 0;
  for (var i = 0; i < rows.length; i++) total += rows[i].count;
  var stops = [];
  var legend = [];
  var acc = 0;
  for (var j = 0; j < rows.length; j++) {
    var s = rows[j];
    var pct = total > 0 ? (s.count / total) * 100 : 0;
    var color = STATUS_COLOR[s.status] || 'var(--v-ink-3)';
    stops.push(color + ' ' + acc + '% ' + (acc + pct) + '%');
    legend.push({ status: s.status, count: s.count, color: color });
    acc += pct;
  }
  return {
    gradient: stops.length > 0 ? 'conic-gradient(' + stops.join(',') + ')' : 'var(--v-line)',
    legend: legend,
    total: total,
  };
}

module.exports = { barData: barData, donut: donut, STATUS_COLOR: STATUS_COLOR };
